const ATTRIBUTES = ['data-edit-mode', 'data-items-count'];

export class HeroSliderHTMLElement extends HTMLElement {
    private automationTimeout: any;
    private currentSlideIndex: number = 0;
    private editMode: boolean = false;
    private itemsTotal: number = 0;
    private dragStartX: number;

    static get observedAttributes(): string[] {
        return ATTRIBUTES;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRIBUTES.includes(name)) {
            return;
        }

        if (oldValue === newValue) {
            return;
        }

        switch (name) {
            case 'data-edit-mode':
                this.editMode = newValue === 'true';
                if (!this.editMode) this.shuffleSlides();
                this.setActiveItem();
                break;
            case 'data-items-count':
                this.itemsTotal = Number.parseInt(newValue);
                if (this.currentSlideIndex >= this.itemsTotal) {
                    this.currentSlideIndex = 0;
                }
                if (!this.editMode) this.shuffleSlides();
                this.setActiveItem();
                break;
            default:
                break;
        }
    }

    private handlePointerDown = (e: PointerEvent): void => {
        this.dragStartX = e.clientX;
    };
    private handlePointerUp = (e: PointerEvent) => {
        if (this.dragStartX - e.clientX < -50 && !this.querySelector('.slider__prev').hasAttribute('disabled')) {
            this.prev();
        } else if (this.dragStartX - e.clientX > 50 && !this.querySelector('.slider__next').hasAttribute('disabled')) {
            this.next();
        }
    }

    private next = (): void => {
        this.currentSlideIndex = (this.currentSlideIndex + 1) % this.itemsTotal;
        this.setActiveItem();
    };

    private prev = (): void => {
        if (this.currentSlideIndex - 1 < 0) {
            this.currentSlideIndex = this.itemsTotal - 1;
        } else {
            this.currentSlideIndex--;
        }
        this.setActiveItem();
    };

    private setActiveItem = () => {
        setTimeout(() => {
            clearTimeout(this.automationTimeout);

            const slideList = Array.from(this.querySelectorAll('.slide'));
        
            for (const el of slideList) {
                el.classList.remove('active');
            }
            slideList[this.currentSlideIndex]?.classList.add('active');

            if (!this.editMode) {
                this.automationTimeout = setTimeout(() => this.next(), 5 * 1000);
            }
        });
    };

    private shuffleSlides = () => {
        setTimeout(() => {
            const slideList = Array.from(this.querySelectorAll('.slide'));
            for (let i = slideList.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [slideList[i], slideList[j]] = [slideList[j], slideList[i]];
            }
            const slides = this.querySelector('.slides');
            const childNodes = Array.from(slides.childNodes);
            const koComments = childNodes.filter(n => n.nodeName === '#comment');
            for (const n of childNodes) {
                slides.removeChild(n);
            }
            let newSlides: Node[];
            if (koComments.length) {
                newSlides = [koComments[0], ...slideList, koComments[1]]
            } else {
                newSlides = [...slideList]
            }
            for (const n of newSlides) {
                slides.appendChild(n);
            }
        })
    }

    public connectedCallback(): void {
        const element = <HTMLElement>this;

        if (!this.editMode) {
            this.shuffleSlides();
        }
        this.setActiveItem();

        const slides: HTMLElement = element.querySelector<HTMLElement>('.slides');
        slides.addEventListener('pointerdown', this.handlePointerDown);
        slides.addEventListener('pointerup', this.handlePointerUp);

        element.addEventListener('click', oEvent => {
            const clickElement = oEvent.composedPath()[0] as HTMLElement;
            if (clickElement.closest('.slider__prev')) {
                this.prev();
            } else if (clickElement.closest('.slider__next')) {
                this.next();
            }
        });
    }

    public disconnectedCallback(): void {
        const slides: HTMLElement = this.querySelector<HTMLElement>('.slides');
        slides.removeEventListener('pointerdown', this.handlePointerDown);
        slides.removeEventListener('pointerup', this.handlePointerUp);
    }
}
